const SurveyAnswerEnum = {
  Yes   : 'Yes',
  No    : 'No',
  Unsure: 'Unsure'
}
export default SurveyAnswerEnum
